// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__9kdUc","loading":"Loading_loading__1WKA8"};